<template>
  <button @click="onClickTidLogin">
    <slot></slot>
  </button>
</template>

<script setup>
  import { UserService } from '@/common/api/api.service'
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import utils from '@/common/util/utils'

  const props = defineProps({
    useRestApi: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['success', 'fail'])
  const route = useRoute()

  const getTidToken = async () => {
    const response = await UserService.getSktToken({
      promotionCode: '',
      returnUrl: location.href,
    })
    const { weburl = '' } = response?.data || {}
    if (weburl) {
      location.href = weburl
    }
  }

  const onClickTidLogin = () => {
    if (props.useRestApi) {
      const loginUrl = utils.login.getMemberSnsLoginUrl({
        type: 'tid',
        callback: location.href,
      })
      location.href = loginUrl
      return
    }
    getTidToken()
  }

  onMounted(() => {
    const { type, token } = route.query
    if (type === 'tid') {
      if (token) {
        emit('success', { token })
      } else {
        emit('fail', { message: 'Failed to get token' })
      }
    }
  })
</script>
